import './embedblock.less'

import {m} from '@codeurs/front'
import React from 'react'
import ReactPlayer, {ReactPlayerProps} from 'react-player'
import {ImageType} from 'types'
import {style} from 'util/style'
import {Block} from './blocks'

type VideoFileType = {
  description: string
  mime_type: string
  path: string
  size: number
  title: string
  type: string
  url: string
}
export type EmbedBlockType = {
  use_file: boolean
  center_iframe: boolean
  iframe: string
  video: VideoFileType
  video_image?: ImageType
}

export type EmbedSwitchType = ReactPlayerProps & EmbedBlockType

const styles = style('embedblock', ['video'])

export const EmbedBlock: React.FC<EmbedBlockType> = ({...props}) => {
  return (
    <Block class={styles}>
      <EmbedSwitch {...props} />
    </Block>
  )
}

export const EmbedSwitch: React.FC<EmbedSwitchType> = ({
  use_file,
  iframe,
  center_iframe,
  video,
  video_image,
  videoPlayerProps = null,
  ...props
}) => {
  // check if video
  if (video) {
    return (
      <EmbedVideoView
        url={use_file ? video.url : iframe}
        videoPlayerProps={videoPlayerProps}
        image={video_image}
      />
    )
  }

  if (iframe && iframe.indexOf('iframe') === -1) {
    return (
      <EmbedVideoView
        url={use_file ? video.url : iframe}
        videoPlayerProps={videoPlayerProps}
      />
    )
  }
  if (!video && iframe.indexOf('iframe')) {
    // check if iframe
    const ratio = !!iframe.match(/youtube|vimeo|maps/)
    const strippedIframe = iframe
      .replace(/(<p[^>]+?>|<p>|<\/p>)/gim, '')
      .replace(/\s/g, ' ')
    return (
      <div
        class={styles('iframe').mod({ratio, center: center_iframe})}
        dangerouslySetInnerHTML={{__html: ensureIframeHasTitle(strippedIframe)}}
      ></div>
    )
  }

  return null
}

export const EmbedVideoView: React.FC<{
  url: string
  videoPlayerProps?: ReactPlayerProps
  className?: string
  image?: ImageType
}> = ({videoPlayerProps, url, className = null, image}) => {
  return (
    <div
      className={styles
        .video('iframecontainer')
        .with(className)
        .mod(image && !image.empty ? 'white' : null)}
      style={{
        backgroundImage: image && !image.empty && `url(${image.src})`
      }}
    >
      <div className={styles.video('iframe')}>
        <ReactPlayer
          url={url}
          width={'100%'}
          height={'100%'}
          controls
          light={false}
          {...videoPlayerProps}
        />
      </div>
    </div>
  )
}

const ensureIframeHasTitle = (
  embed: string,
  defaultTitle: string = 'Embedded content'
): string => {
  const iframeRegex = /<iframe[^>]*>/i
  const titleAttrRegex = /<iframe[^>]*\btitle\s*=\s*(['"]).*?\1/i

  // Check if the embed contains an iframe
  if (!iframeRegex.test(embed)) {
    return embed // No iframe tag found; return as is
  }

  // Check if iframe already has a title attribute
  if (titleAttrRegex.test(embed)) {
    return embed // Already has a title; no change needed
  }

  // Add title attribute right after <iframe
  return embed.replace(iframeRegex, match => {
    return match.replace('<iframe', `<iframe title="${defaultTitle}"`)
  })
}
